import { Box, Tab, Tabs } from '@mui/material';
import { RingMyPhoneButton } from '../../../components/ringMyPhone/RingMyPhoneButton';
import { SyntheticEvent, useState } from 'react';
import { tabsSticky, tabsWrapper } from '../../../../../shared/lib/theme/styleConstants';
import { PageHeading } from '../../../../../shared/lib/common/PageHeading';
import { TabPanel } from '../../../../../shared/lib/common/Tabpanel';
import { LABEL_RING_MY_PHONE_LOGS, LABEL_RING_MY_PHONE_SETTINGS, LABEL_RING_MY_PHONE_TM } from '../../../app/constants';
import { LABEL_RING_MY_PHONE_INFO } from '../../../../../shared/lib/constants';
import { withTrademark } from '../../../../../shared/lib/common/Tokenizer';
import { DashboardContainer } from '../../../components/dashboard/DashboardContainer';
import RingMyPhoneSettings from '../../../components/ringMyPhone';
import RingMyPhoneLogs from '../../../components/ringMyPhone/RingMyPhoneLogs';
import RingMyPhoneInfo from '../../../components/ringMyPhone/RingMyPhoneInfo';
import { handleTabs } from '../../utils';

const RingMyPhonePage = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <DashboardContainer>
      <Box display="flex" alignItems="flex-end" justifyContent="space-between">
        <PageHeading color="blackOne" title={withTrademark(LABEL_RING_MY_PHONE_TM)} subTitle="" />
        <Box mb={3}>
          <RingMyPhoneButton />
        </Box>
      </Box>

      <Box sx={tabsWrapper}>
        <Box sx={tabsSticky}>
          <Tabs value={value} onChange={handleChange} aria-label="ring my phone tabs">
            <Tab sx={{ textTransform: 'none' }} label={<span style={{ whiteSpace: 'nowrap' }}>{withTrademark(LABEL_RING_MY_PHONE_SETTINGS)}</span>} {...handleTabs(0)} />
            <Tab sx={{ textTransform: 'none' }} label={<span style={{ whiteSpace: 'nowrap' }}>{withTrademark(LABEL_RING_MY_PHONE_LOGS)}</span>} {...handleTabs(1)} />
            <Tab sx={{ textTransform: 'none' }} label={<span style={{ whiteSpace: 'nowrap' }}>{withTrademark(LABEL_RING_MY_PHONE_INFO)}</span>} {...handleTabs(2)} />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <RingMyPhoneSettings />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <RingMyPhoneLogs />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <RingMyPhoneInfo />
        </TabPanel>
      </Box>
    </DashboardContainer>
  );
};

export default RingMyPhonePage;
